import { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@alltrails/shared/denali/components/Button';
import OutlinedTextField from '@alltrails/shared/components/OutlinedTextField';
import * as styles from './styles/styles.module.scss';
import { FormattedMessage } from '@alltrails/shared/react-intl';

class TrailDetailItemForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: props.text
    };
  }

  handleChange = e => {
    e.preventDefault();
    if (this.props.submitting) {
      return;
    }

    this.setState({ text: e.currentTarget.value });
  };

  handleSubmit = e => {
    e.preventDefault();
    if (this.props.submitting) {
      return;
    }

    this.props.handleSubmit(this.state.text);
  };

  renderFormButtons = () => {
    return (
      <div className={styles.buttonContainer}>
        <Button
          disabled={this.props.submitting}
          testId="trail-detail-item-submit"
          text={<FormattedMessage defaultMessage="Submit" />}
          type="submit"
          variant="primary"
          width="full"
        />
        <Button
          onClick={this.props.handleCancelPress}
          text={<FormattedMessage defaultMessage="Cancel" />}
          testId="trail-item-form-cancel"
          variant="flat"
        />
      </div>
    );
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <OutlinedTextField
          name="description"
          errorMessage=""
          value={this.state.text}
          label={this.props.label}
          changeHandler={this.handleChange}
          multiline
          verticalResize
          rows={8}
        />
        {this.renderFormButtons()}
      </form>
    );
  }
}

TrailDetailItemForm.propTypes = {
  maxLength: PropTypes.number,
  text: PropTypes.string,
  handleCancelPress: PropTypes.func,
  handleSubmit: PropTypes.func,
  errorMessage: PropTypes.string,
  submitting: PropTypes.bool,
  label: PropTypes.string
};

export default TrailDetailItemForm;
